import { useContainerEligibleCustomers } from '~/common/hooks';
import {
  SharedCustomerSelector,
  useCustomerChangeHandler,
} from '~/purchase/components';

function ContainerEligibleCustomerSelector() {
  const getCustomersByUser = useContainerEligibleCustomers();
  const onChange = useCustomerChangeHandler();

  return (
    <SharedCustomerSelector
      customerQuery={getCustomersByUser}
      onChange={onChange}
    />
  );
}

export default ContainerEligibleCustomerSelector;
